import useAuth from '../hooks/useAuth';
import DashboardContent from './DashboardContent';
import StaffDashboard from './StaffDashboard';

export default function Dashboard() {
  const { user } = useAuth();
  if (user.Role.baseRole === 'superadmin') {
    return <DashboardContent />;
  }

  return <StaffDashboard />;
}
